import React, { ReactElement, useState } from 'react';
import {Row, Col} from 'antd';
import { ReactComponent as DoubleArrowUp } from '../../../../assets/images/svg/double-arrow-up.svg';
import { ReactComponent as DoubleArrowDown } from '../../../../assets/images/svg/double-arrow-down.svg';
import DashboardCard from './DashboardCard';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';
import { RootState } from '../../../../store';
import { useSelector } from 'react-redux';

const Dashboard = (): ReactElement => {

  const [isTagListOpen, setIsTagListOpen] = useState(false);
  const {totalClaimedAmount, totalApprovedAmount, shortPaidClaims, notPaidClaims, reconciledClaims,
    totalSettledClaims, pendingAmount, tdsAmount, paidAmount} = useSelector((state: RootState): ReconciliationState =>
    state.reconciliation || []);

  const handleOpenClose = (): any => {
    setIsTagListOpen(!isTagListOpen);
  };
  return (
  <div>
    <div className="ant-tabs-content-holder tab-custom-container">
      <Row
        justify="space-between"
        className="flex-element flex-row"
      >
        <DashboardCard width="w-20 p-xs" title="Total Claimed Amount" prefixRequired="true" body={totalClaimedAmount} />
        <DashboardCard width="w-20 p-xs" title="Total Approved Amount" prefixRequired="true" body={totalApprovedAmount} />
        <DashboardCard width="w-20 p-xs" title="Paid Amount" prefixRequired="true" body={paidAmount} />
        <DashboardCard width="w-20 p-xs" title="TDS Amount" prefixRequired="true" body={tdsAmount} />
        <DashboardCard width="w-20 p-xs" title="Pending Amount" prefixRequired="true" body={pendingAmount} />
      </Row>
      <Row
        justify="center"
        className="claim-list-divider-wrapper m-t--20"
      >
        <Col md={2} className="center-icon">
          {
            isTagListOpen
              ? <DoubleArrowUp
                className="mouse-pointer"
                onClick={handleOpenClose}
              />
              : <DoubleArrowDown
                className="mouse-pointer"
                onClick={handleOpenClose}
              />
          }
        </Col>
      </Row>
      <Row
        className={
          isTagListOpen
            ? 'flex-element flex-row dashboard-card'
            : 'inpatient-tags-wrapper hide'
        }
        justify="space-between"
      >
        <DashboardCard width="w-25 p-xs" title="Total Settled Claims" body={totalSettledClaims} />
        <DashboardCard width="w-25 p-xs" title="Reconciled Claims" body={reconciledClaims} />
        <DashboardCard width="w-25 p-xs" title="Short Paid Claims" body={shortPaidClaims} />
        <DashboardCard width="w-25 p-xs" title="Not Paid Claims" body={notPaidClaims} />
      </Row>
    </div>
  </div>);
  };
export default Dashboard;
